import React from 'react'
import { Link } from 'react-router'
import FontIcon from 'material-ui/FontIcon'
import IconButton from 'material-ui/IconButton'
import { ResponsiveDialog } from 'common-frontend'
import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card'
import { HelpEmail } from 'components'

import './serpPreview.scss'

export default class SERPPreview extends React.Component {
  static propTypes = {
    url:                      React.PropTypes.string.isRequired,
    pageTitle:                React.PropTypes.string,
    pageTitleCount:           React.PropTypes.number,
    metaDescription:          React.PropTypes.string,
    metaDescriptionCount:     React.PropTypes.number,
    pageTitleFormula:         React.PropTypes.string,
    metaDescriptionFormula:   React.PropTypes.string,
    embeddedInTemplateEditor: React.PropTypes.bool,
    errored:                  React.PropTypes.bool.isRequired,
    expanded:                 React.PropTypes.bool
  }
  static defaultProps = {
    embeddedInTemplateEditor: false,
    expanded:                 false
  }

  constructor(props) {
    super(props)
    this.state = {
      ...this.truncateFromProps(props),
      showDialog: false,
      expanded: props.expanded,
      pageTitleLine: {
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0
      },
      metaDescriptionLine: {
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0
      }
    }
  }

  componentDidMount() {
    if (this.state.expanded)
      this.setLines()
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.expanded && !prevState.expanded)
      this.setLines()
    else if (!this.state.expanded && prevState.expanded)
      this.unsetLines()
    else if (this.state.expanded &&
      (prevProps.metaDescription !== this.props.metaDescription || prevProps.pageTitle !== this.props.pageTitle))
      this.setLines()
  }

  componentWillReceiveProps(nextProps) {
    this.setState(this.truncateFromProps(nextProps))
  }

  setLines() {
    const container = this.refs.container

    const pageTitleY = this.refs.pageTitle.offsetTop + this.refs.pageTitle.offsetHeight + 16
    const pageTitleFormulaY =
      this.refs.pageTitleFormula.parentElement.offsetTop + 16

    const metaDescriptionY = this.refs.metaDescription.offsetTop + this.refs.metaDescription.offsetHeight + 16
    const metaDescriptionFormulaY =
      this.refs.metaDescriptionFormula.offsetTop + this.refs.metaDescriptionFormula.parentElement.offsetTop

    this.setState({
      pageTitleLine: {
        x1: 40,
        y1: pageTitleY,
        x2: 40,
        y2: pageTitleFormulaY
      },
      metaDescriptionLine: {
        x1: (container.offsetWidth / 3),
        y1: metaDescriptionY + 5,
        x2: (container.offsetWidth / 2),
        y2: metaDescriptionFormulaY
      }
    })
  }

  unsetLines() {
    this.setState({
      pageTitleLine: {
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0
      },
      metaDescriptionLine: {
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0
      }
    })
  }

  truncateFromProps(props) {
    const pageTitleTruncated = props.pageTitle ? this.truncate(props.pageTitle, 70, ' ...') : null
    const metaDescriptionTruncated = props.metaDescription ? this.truncate(props.metaDescription, 320, ' ...') : null
    const urlTruncated = this.truncate(props.url, 85, '...')

    return { pageTitleTruncated, metaDescriptionTruncated, urlTruncated }
  }

  // from https://gist.github.com/mseeley/1637329
  truncate(text, length, suffix) {
    if (text.length <= length)
      return text

    const lastword = /\w+$/,
        blacklist = /[\s\u0021-\u002F\u003A-\u0040\u005B-\u0060\u007B-\u007F\u00A0-\u00BF]$/,
        hellip = '\u2026',
        empty = ''

    suffix = suffix || hellip;
    text = text.slice(0, length - suffix.length).replace(lastword, empty);
    while (text && blacklist.test(text)) {
        text = text.replace(blacklist, empty);
    }
    return text ? text + suffix : empty;
  }

  getTemplateName(formula) {
    if (formula.indexOf('-te_ix') > -1)
      return 'index'
    else if (formula.indexOf('-te_pg') > -1)
      return 'page'
    else if (formula.indexOf('-te_se') > -1)
      return 'search'
    else if (formula.indexOf('-te_pr') > -1)
      return 'product'
    else if (formula.indexOf('-te_co') > -1)
      return 'collection'
    else if (formula.indexOf('-te_bl') > -1)
      return 'blog'
    else if (formula.indexOf('-te_ar') > -1)
      return 'article'
    else if (formula.indexOf('-te_44') > -1)
      return '404'
    else if (formula.indexOf('-te_df') > -1)
      return 'default'
  }

  render() {
    if (this.props.errored === true) {
      return (
        <div className='serppreview' ref='container' style={{ position: 'relative' }}>
          <Card>
            <CardText>
              <h5>Error: Couldn't get HTML for {this.props.url}</h5>
              <p>Check the URL and try again.</p>
              <p>If the problem persists, email <HelpEmail /> with a screenshot and details</p>
            </CardText>
          </Card>
        </div>
      )
    }

    if (this.props.pageTitleCount === 0) {
    // bomb out because no page title is a critical issue, there's no point rendering anything
     return (
      <ul className='icon-font-list'>
        <li className='icon-font-list__list-item icon-font-list__list-item--warning'>
          <h5>There is no HTML page title. This is a critical SEO problem {this.props.url}</h5>
        </li>
        <li className="medium-spacing2">
          <p className="body2">
            If you're on Plug in SEO Plus just <a href='mailto:help+plus@pluginseo.com'>email help+plus@pluginseo.com</a> and we'll sort this out for you, no charge.
          </p>
        </li>
        <li>
          <p className="body2">
            Or, <Link to={`/checks/seoproblems?ah=${this.props.url}`}>Get more details including how to fix</Link>
          </p>
        </li>
      </ul>
     )
   }

   let metaDescriptionTruncated = this.state.metaDescriptionTruncated
   if (this.props.metaDescriptionCount === 0) {
     metaDescriptionTruncated = "<strong>No meta description. Search engines will select the text they think is most relevant from the page for the user's search</strong>"
   }

// TODO: raw HTML? http://localhost:8080/serppreview?u=https://www.bigcommerce.com

    return (
      <div className='serppreview' ref='container' style={{ position: 'relative' }}>
        <Card expanded={this.state.expanded}>
          <div style={{position: 'absolute', top: 5, right: 5, zIndex: 1000}}>
            <IconButton iconClassName="material-icons" onTouchTap={() => this.setState({ expanded: !this.state.expanded })}>
              info_outline
            </IconButton>
          </div>
          <svg style={{ position: 'absolute', width: '100%', height: '100%' }}>
            <line x1={this.state.pageTitleLine.x1} y1={this.state.pageTitleLine.y1} x2={this.state.pageTitleLine.x2} y2={this.state.pageTitleLine.y2}
              style={{ stroke: '#455A64', strokeWidth: 2 }}
            />
          </svg>
          <svg style={{ position: 'absolute', width: '100%', height: '100%' }}>
            <line x1={this.state.metaDescriptionLine.x1} y1={this.state.metaDescriptionLine.y1} x2={this.state.metaDescriptionLine.x2} y2={this.state.metaDescriptionLine.y2}
              style={{ stroke: '#455A64', strokeWidth: 2 }} />
          </svg>
          <CardText>
            <div className='serppreview__serp serppreview__serp-g'>
              <div className='serppreview__serp-rc'>
                <h3 className='serppreview__serp-r' ref='pageTitle'>
                  <a href={this.props.url} dangerouslySetInnerHTML={{__html: this.state.pageTitleTruncated}}>
                  </a>
                </h3>
                <div className='serppreview__serp-s'>
                  <div>
                    <div className="serppreview__serp-f serppreview__serp-kv" style={{ whiteSpace: 'nowrap' }}>
                      <cite className="serppreview__serp-Rm">
                        {this.state.urlTruncated}
                      </cite>
                    </div>
                    <span className="serppreview__serp-st" ref='metaDescription' dangerouslySetInnerHTML={{__html: metaDescriptionTruncated}}>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </CardText>
          <CardText className='serppreview__explained' style={{ position: 'relative', color: '#455A64' }} expandable={true}>
            <div ref='pageTitleFormula' className='serppreview__explained__column'>
              <h4>HTML Page title</h4>
              {this.renderPageTitleWarning()}
              {this.renderPageTitleFormula()}
            </div>
            <div ref='metaDescriptionFormula' className='serppreview__explained__column'>
              <h4>HTML Meta description</h4>
              {this.renderMetaDescriptionWarning()}
              {this.renderMetaDescriptionFormula()}
            </div>
          </CardText>
        </Card>
      </div>
    )
  }

  renderPageTitleWarning() {
    if (this.props.pageTitleCount > 1) {
      return (
        <ul className='icon-font-list'>
          <li className='icon-font-list__list-item icon-font-list__list-item--warning'>
            <strong>There's more than one page title</strong>
          </li>
          <li>
            <p className="body2">
              If you're on Plug in SEO Plus just <a href='mailto:help+plus@pluginseo.com'>email help+plus@pluginseo.com</a> and we'll sort this out for you, no charge.
            </p>
            <p className="body2 small-spacing--top">
              Or, <Link to={`/checks/seoproblems?ah=${this.props.url}`}>Get more details including how to fix</Link>
            </p>
          </li>
        </ul>
      )
    } else {
      return null
    }
  }

  renderPageTitleFormula() {
    if (this.props.pageTitleFormula) {
      return (
        <div>
          {this.props.pageTitleFormula.indexOf('-me') > -1 &&
            <span>
              <p className="body2">
                This one is a manually entered page title
              </p>
              <p className="body2 small-spacing--top">
                To change, find the product/page/collection etc. in your Shopify admin and 'Edit website SEO'
              </p>
            </span>
          }
          {this.props.pageTitleFormula.indexOf('-te_') > -1 &&
            <span>
            <p className="body2">
              This one comes from the {this.getTemplateName(this.props.pageTitleFormula)} page title template
            </p>
            {!this.props.embeddedInTemplateEditor &&
              <p className="body2 small-spacing--top">
                To change, <Link to={`/plus/manage/${this.getTemplateName(this.props.pageTitleFormula)}`}>edit the template</Link>
              </p>
            }
            {this.props.embeddedInTemplateEditor &&
              <p className="body2 small-spacing--top">
                To change, edit the 'Title template' above
              </p>
            }
            </span>
          }
          {this.props.pageTitleFormula.indexOf('-ap') > -1 &&
            <p className="body2">
              The page title append has been added to the end <Link to='/plus/manage/appender'>Edit appender</Link>
            </p>
          }
          {this.props.pageTitleFormula.indexOf('-tr') > -1 &&
            <p className="body2">
              It has been truncated before being presented to search engines. <Link to='/plus/manage/advanced'>Edit truncator</Link>
            </p>
          }
        </div>
      )
    } else {
      return null
    }
  }

  renderMetaDescriptionWarning() {
    if (this.props.metaDescriptionCount === 0) {
      return (
        <ul className='icon-font-list'>
          <li className='icon-font-list__list-item icon-font-list__list-item--warning'>
            <strong>There's no meta description</strong>
          </li>
          <li>
            { this.props.embeddedInTemplateEditor &&
              <p className="body2">
                Create one by editing the 'Description template' above
              </p>
            }
            <p className="body2 small-spacing--top">
              <a href='https://support.pluginuseful.com/hc/en-us/articles/23534811160596-How-do-search-engines-use-meta-descriptions' target='_blank'>
                Find out more about meta descriptions
              </a>
            </p>
          </li>
        </ul>
      )
    } else if (this.props.metaDescriptionCount > 1) {
      return (
        <ul className='icon-font-list'>
          <li className='icon-font-list__list-item icon-font-list__list-item--clear'>
            <strong>There's more than one meta description</strong>
            <p className="body2">
              If you're on Plug in SEO Plus just <a href='mailto:help+plus@pluginseo.com'>email help+plus@pluginseo.com</a> and we'll sort this out for you, no charge.
            </p>
            <p className="body2 small-spacing--top">
              Or, <Link to={`/checks/seoproblems?ah=${this.props.url}`}>Get more details including how to fix</Link>
            </p>
          </li>
        </ul>
      )
    } else {
      return null
    }
  }

  renderMetaDescriptionFormula() {
    if (this.props.metaDescriptionFormula && this.props.metaDescriptionCount > 0) {
      return (
        <div>
          {this.props.metaDescriptionFormula.indexOf('-me') > -1 &&
            <span>
              <p className="body2">
                This one is a manually entered meta description
              </p>
              <p className="body2 small-spacing--top">
                To change, find the product/page/collection etc. in your Shopify admin and 'Edit website SEO'
              </p>
            </span>
          }
          {this.props.metaDescriptionFormula.indexOf('-te_') > -1 &&
            <span>
              <p className="body2">
                This one comes from the {this.getTemplateName(this.props.metaDescriptionFormula)} meta description template
              </p>
              {!this.props.embeddedInTemplateEditor &&
                <p className="body2 small-spacing--top">
                  To change, <Link to={`/plus/manage/${this.getTemplateName(this.props.metaDescriptionFormula)}`}>edit the template</Link>
                </p>
              }
              {this.props.embeddedInTemplateEditor &&
                <p className="body2 small-spacing--top">To change, edit the 'Description template' above</p>
              }
            </span>
          }
          {this.props.metaDescriptionFormula.indexOf('-tr') > -1 &&
            <p className="body2">
              It has been truncated before being presented to search engines. <Link to='/plus/manage/advanced'>Edit truncator</Link>
            </p>
          }
        </div>
      )
    } else {
      return null
    }
  }
}



// WEBPACK FOOTER //
// ./app/components/serppreview/SERPPreview.js